import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { InsertCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsDefaultLabels, ProductionCommandsObjectOptions, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';
import { getSecondsFromTimeSpan, getTimeSpanWithHoursFromSeconds } from '@src/suite/common/utils/timing-format';

@Component({
    selector: 'st-insert-take-command-dialog',
    templateUrl: './insert-take-command-dialog.html',
    styleUrls: ['./insert-take-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-insert-take-command-dialog' },
})
export class InsertTakeCommandDialogComponent {
    public ProductionFieldName = ProductionFieldName;
    public ProductionCommandsDefaultLabels = ProductionCommandsDefaultLabels;
    public ProductionCommandsObjectOptions = ProductionCommandsObjectOptions;
    public command = input<InsertCommand>();
    public commandChange = output<InsertCommand>();
    public onEnterEmitter = output<InsertCommand>();

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            if (
                (fieldName === ProductionFieldName.AT || fieldName === ProductionFieldName.TO) &&
                this.command()[ProductionFieldName.TO] &&
                this.command()[ProductionFieldName.AT] < this.command()[ProductionFieldName.TO]
            ) {
                const timeValue = getSecondsFromTimeSpan(this.command()[ProductionFieldName.TO]) - getSecondsFromTimeSpan(this.command()[ProductionFieldName.AT]);
                this.command()[ProductionFieldName.TIME_VALUE] = getTimeSpanWithHoursFromSeconds(timeValue);
            }
            this.commandChange.emit(this.command());
        }
    }

    public saveCommand(event: any, fieldName: ProductionFieldName) {
        this.onCommandsObjectChange(event, fieldName);
        this.onEnterEmitter.emit(this.command());
    }

    public onKeyup(event: KeyboardEvent, fieldName: ProductionFieldName) {
        if (!(event?.target as unknown as { value: string })?.value) {
            return;
        }
        if (event.keyCode === 13 || event.key === 'Enter') {
            this.saveCommand((event?.target as unknown as { value: string }).value, fieldName);
        }
    }
}
